/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Integrations_LinkInputs */

const cs_settings_office_integrations_link = /** @type {(inputs: Settings_Office_Integrations_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality RK a katastr`)
};

const en_settings_office_integrations_link = /** @type {(inputs: Settings_Office_Integrations_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality RK keys and cadastre`)
};

/**
* | output |
* | --- |
* | "Sreality RK keys and cadastre" |
*
* @param {Settings_Office_Integrations_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_integrations_link = /** @type {((inputs?: Settings_Office_Integrations_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Integrations_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_integrations_link(inputs)
	return cs_settings_office_integrations_link(inputs)
});